module.exports = __webpack_public_path__ + "img/rascrut-11.beefa5d7.webp";